import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchTariffsAndInsuranceProvidersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchTariffsAndInsuranceProvidersQuery = { readonly __typename?: 'Query', readonly minInsuranceProviders: ReadonlyArray<{ readonly __typename?: 'MinInsuranceProvider', readonly id: string, readonly name?: string | null } | null>, readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly priceTariffs: { readonly __typename?: 'PriceTariffsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'PriceTariff', readonly id: string, readonly name: string, readonly externalReference?: { readonly __typename?: 'PriceTariffExternalReference', readonly foreignId: string, readonly origin: Types.PriceTariffExternalReferenceOrigin } | null }> } } };


export const FetchTariffsAndInsuranceProvidersDocument = gql`
    query fetchTariffsAndInsuranceProviders {
  minInsuranceProviders {
    id
    name
  }
  priceListV2 {
    priceTariffs {
      edges {
        id
        name
        externalReference {
          foreignId
          origin
        }
      }
    }
  }
}
    `;

/**
 * __useFetchTariffsAndInsuranceProvidersQuery__
 *
 * To run a query within a React component, call `useFetchTariffsAndInsuranceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTariffsAndInsuranceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTariffsAndInsuranceProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchTariffsAndInsuranceProvidersQuery(baseOptions?: Apollo.QueryHookOptions<FetchTariffsAndInsuranceProvidersQuery, FetchTariffsAndInsuranceProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTariffsAndInsuranceProvidersQuery, FetchTariffsAndInsuranceProvidersQueryVariables>(FetchTariffsAndInsuranceProvidersDocument, options);
      }
export function useFetchTariffsAndInsuranceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTariffsAndInsuranceProvidersQuery, FetchTariffsAndInsuranceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTariffsAndInsuranceProvidersQuery, FetchTariffsAndInsuranceProvidersQueryVariables>(FetchTariffsAndInsuranceProvidersDocument, options);
        }
export type FetchTariffsAndInsuranceProvidersQueryHookResult = ReturnType<typeof useFetchTariffsAndInsuranceProvidersQuery>;
export type FetchTariffsAndInsuranceProvidersLazyQueryHookResult = ReturnType<typeof useFetchTariffsAndInsuranceProvidersLazyQuery>;
export type FetchTariffsAndInsuranceProvidersQueryResult = Apollo.QueryResult<FetchTariffsAndInsuranceProvidersQuery, FetchTariffsAndInsuranceProvidersQueryVariables>;